export default [
  {
    key: 'switch',
    title: '开关',
    fixed: 'left',
    width: 40
  },
  {
    key: 'ruleId',
    title: '任务ID',
    fixed: 'left',
    width: 48
  },
  {
    key: 'controlOpName',
    title: '管控人员',
    width: 80
  },
  {
    key: 'mediaName',
    title: '媒体',
    width: 70
  },
  {
    key: 'middleGameName',
    title: '中间件游戏',
    width: 76,
    overflow: true
  },
  {
    key: 'platformName',
    title: '平台',
    width: 36
  },
  {
    key: 'consume',
    title: '消耗配置',
    width: 488
  },
  {
    key: 'triggerRules',
    title: '触发规则',
    width: 180
  },
  {
    key: 'shutDownCondition',
    title: '关停条件',
    width: 170
  },
  {
    key: 'status',
    title: '任务状态',
    width: 60
  },
  {
    key: 'resultDesc',
    title: '今日执行结果',
    width: 190
  },
  {
    key: 'upTime',
    title: '修改时间',
    width: 124
  },
  {
    key: 'lastUpOpName',
    title: '最后修改人',
    width: 80
  },
  {
    key: 'control',
    title: '操作',
    width: 142
  }
]
